/* eslint-disable prettier/prettier */
import sirepAPI from "@/api/sirepApi";

export const dataSegip = async ({ commit }, { data, type }) => {
  try {

    const userData = JSON.parse(localStorage.getItem("user") || "{}");
    const ci_usuario = userData.nro_documento;

    let payload = {};

    if (type === "complete" && data && data.token) {
      payload = {
        token: data.token,
        ci_usuario,
        type,
      };
    } else {
      const nro_documento = data && data.nro_documento ? data.nro_documento : "";
      const complemento = data && data.complemento ? data.complemento : "";

      payload = {
        nro_documento,
        complemento,
        ci_usuario,
        type,
      };
    }
    const response = await sirepAPI.post("/segip/consult", payload);
    const resp = response.data;
    if (!resp.found) {
      commit("segipResponse", {
        data: resp.message || "No existe información",
      });

      return resp;
    }

    const responseToReturn = Object.assign({}, resp.data || {}, {
      found: resp.found,
      token: resp.token || null,
      type:
        resp.data && resp.data.type
          ? resp.data.type
          : resp.type || type,
    });

    commit("segipResponse", {
      data: responseToReturn,
    });

    return responseToReturn;
  } catch (error) {
    console.error(
      "Error Vue SEGIP:",
      error.response ? error.response.data : error.message
    );

    return {
      found: false,
      message:
        error &&
        error.response &&
        error.response.data &&
        error.response.data.message
          ? error.response.data.message
          : "Error en la consulta",
      data: null,
    };
  }
};

export const loadDepartments = async() => {
    try {
        const { data } = await sirepAPI.get("/usuario/departments_names")
        return { data }
    } catch (error) {
        return { message: error }
    }
}

export const loadProvinces = async({ commit }, department) => {
    try {
        const { data } = await sirepAPI.get("/usuario/provinces_names/" + department)
            //commit("listProvinces", {data})
        return { data }
    } catch (error) {
        return { message: error }
    }
}

export const loadPenitentiaries = async() => {
    try {
        const { data } = await sirepAPI.get("/usuario/penitentiaries_names")
        return { data }
    } catch (error) {
        return { message: error }
    }
}

export const loadPenitentiary = async({ commit }, id_recinto_penitenciario) => {
    try {
        // console.log(id_recinto_penitenciario)
        const { data } = await sirepAPI.get("/usuario/penitentiary/" + id_recinto_penitenciario)
        return { data }
    } catch (error) {
        return { message: error }
    }
}

export const loadRoles = async() => {
    try {
        const { data } = await sirepAPI.get("/usuario/roles_names")
        return { data }
    } catch (error) {
        return { message: error }
    }
}

// Cargar la lista de usuarios de la api BD
export const loadUsers = async({ commit }) => {
    try {
        const { data } = await sirepAPI.get("usuario/read_user")

        // commit('cleanPenitentiary')

        return { data }
    } catch (error) {
        return { message: error }
    }
}

// Creamos un nuevo registro de recinto penitenciario
export const createUser = async({ commit }, dataToSave) => {
    try {
        // const userLogged = 1
        let userLogged = JSON.parse(localStorage.getItem('user')).nro_documento
            // console.log('action createUser', dataToSave)

        const { data } = await sirepAPI.post("usuario/create_user/" + userLogged, dataToSave)
            //llamamos a la mutacion mediante un commit
            // commit('addPenitentiary', dataToSave)
        return { data }

    } catch (error) {
        return { message: error }
    }
}

// Leemos un registro de recinto penitenciario
export const infoUser = async({ commit }, id_usuario) => {
    try {
        const { data } = await sirepAPI.get("usuario/info_user/" + id_usuario)
            // commit('infoUser', data)
        return data
    } catch (error) {
        return { message: error }
    }
}

// Cargar la lista de roles del usuario
export const loadRolesUser = async({ commit }, id_usuario) => {
    try {
        // console.log('actions loadRolesUser', id_usuario)
        const { data } = await sirepAPI.get("usuario/info_roles_user/" + id_usuario)
            // console.log(data)
            // commit('cleanPenitentiary')
        return { data }
    } catch (error) {
        return { message: error }
    }
}

// Cargar el password del usuario
export const loadPasswordUser = async({ commit }, id_usuario) => {
    try {
        const { data } = await sirepAPI.get("usuario/info_password_user/" + id_usuario)
        return { data }
    } catch (error) {
        return { message: error }
    }
}

export const updateUser = async({ commit }, dataToSave) => {
    try {
        let userLogged = JSON.parse(localStorage.getItem('user')).nro_documento
        const { data } = await sirepAPI.post("usuario/update_user/" + userLogged, dataToSave)
            // commit('addPenitentiary', dataToSave)
        return { data }
    } catch (error) {
        return { message: error }
    }
}

export const updatePassword = async({ commit }, dataToSave) => {
    try {
        let userLogged = JSON.parse(localStorage.getItem('user')).nro_documento
        const { data } = await sirepAPI.post("usuario/update_password/" + userLogged, dataToSave)
        return { data }
    } catch (error) {
        return { message: error }
    }
}

export const deleteUser = async({ commit }, dataToSave) => {
    try {
        let userLogged = JSON.parse(localStorage.getItem('user')).nro_documento
        const dataToEliminate = { 'id_usuario': dataToSave }
        const { data } = await sirepAPI.post("usuario/delete_user/" + userLogged, dataToEliminate)
            // commit('addPenitentiary', dataToSave)
        return { data }
    } catch (error) {
        return { message: error }
    }
}

export const sendMail = async({ commit }, dataToSend) => {
    try {
        let userLogged = JSON.parse(localStorage.getItem('user')).nro_documento
            // console.log('action sendMail', dataToSend)
        const { data } = await sirepAPI.post("usuario/send_mail_user/" + userLogged, dataToSend)
        return { data }
    } catch (error) {
        return { message: error }
    }
}

export const restoreCode = async({ commit }, dataToSend) => {
    try {
        // console.log('actions', dataToSend)
        const { data } = await sirepAPI.post("usuario/restore_code/", dataToSend)
        return { data }
    } catch (error) {
        return { message: error }
    }
}

export const verifyCode = async({ commit }, dataToSend) => {
    try {
        // console.log('actions', dataToSend)
        const { data } = await sirepAPI.post("usuario/verify_code/", dataToSend)
        return { data }
    } catch (error) {
        return { message: error }
    }
}

export const userRoles = async() => {
    try {
        let userLogged = JSON.parse(localStorage.getItem('user')).usuario
        userLogged = userLogged.split(/[(,]+/)
        userLogged = userLogged[1]


        // console.log(userLogged)
        const { data } = await sirepAPI.get("usuario/roles_user/" + userLogged)
            // console.log(data)
        return data
            // const { data } = await sirepAPI.post("usuario/roles_user/" + userLogged)
            // return { data }
            // console.log(data)
    } catch (error) {
        return { message: error }
    }
}